import type {
    ActionAPIError,
    ActionNetworkError,
    ActionResetNetworkError
} from 'shared/store/actions'
import { fetchPageData } from 'shared/store/actions'
import endpoints from 'shared/store/endpoints'
import type { Coupon, HomeData } from 'shared/types'
import type { RootState } from 'shared/store/root'
import type {
    ActionPrivilegesDataResponse,
    ActionAddCouponSuccess
} from 'shared/store/kingdom/privileges'

export type ActionHomePageDataResponse = {
    type: 'PAGE_DATA_HOMEPAGE_RESPONSE',
    data: HomeData
}

export type ActionRootPageResponse = {
    type: 'PAGE_DATA_ROOT_RESPONSE',
    data: RootState
}

type ActionHomePageError = {
    type: 'HOMEPAGE_ERROR',
    error: boolean
}

type ActionPrivilegesLogout = {
    type: 'LOGOUT'
}

export type ActionPrivilegesCoupons = {
    type: 'PRIVILEGES_COUPONS',
    coupons: Array<Coupon>
}

const fetchHomePageData = () =>
    fetchPageData(endpoints.pages.home, 'PAGE_DATA_HOMEPAGE_RESPONSE')

const actionError = (error: boolean): ActionHomePageError => ({
    type: 'HOMEPAGE_ERROR',
    error
})

export { actionError, fetchHomePageData }

export type Action =
    | ActionHomePageDataResponse
    | ActionAPIError
    | ActionNetworkError
    | ActionHomePageError
    | ActionPrivilegesLogout
    | ActionRootPageResponse
    | ActionAddCouponSuccess
    | ActionResetNetworkError
    | ActionNetworkError
    | ActionPrivilegesDataResponse
